import React, { useState, useEffect } from 'react';
import burger from '@/components/ui/icons/burger.svg';
import close from '@/components/ui/icons/close.svg';
const BurgerMenu = props => {
  const [clicked, setClicked] = useState(false);
  const { myClicked } = props;

  useEffect(() => {
    if (typeof myClicked === 'function') {
      myClicked(clicked);
    }
  }, [clicked, myClicked]);

  const handleToggle = () => {
    setClicked(prev => !prev);
  };

  return (
    <div className="myBurger--button">
      <button onClick={handleToggle} className="burger--button-toogle">
        <img
          style={{ width: '30px ', minWidth: '30px' }}
          src={clicked ? close : burger}
          alt="button"
        />
      </button>
    </div>
  );
};

export default BurgerMenu;
